import { render, staticRenderFns } from "./SdgList.vue?vue&type=template&id=fef77960&scoped=true"
import script from "./SdgList.vue?vue&type=script&lang=ts"
export * from "./SdgList.vue?vue&type=script&lang=ts"
import style0 from "./SdgList.vue?vue&type=style&index=0&id=fef77960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef77960",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SDG: require('/home/runner/work/assessment-service/assessment-service/frontend/components/SDG.vue').default})
